import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FuseSharedModule } from "@fuse/shared.module";
import { DisabledWhenExpiredDirective } from "@vadmin/account/auth";
import { ContentComponent } from "app/layout/components/content/content.component";

@NgModule({
    declarations: [ContentComponent],
    imports: [RouterModule, FuseSharedModule, DisabledWhenExpiredDirective],
    exports: [ContentComponent],
})
export class ContentModule {}
